const SUPPORT_CARDS_DEFAULT_URL = 'https://ui.cltp.co/flyinstatic/common/themes/v2/img/support-cards.png'
const SUPPORT_CARDS_AR_URL = 'https://ui.cltp.co/flyinstatic/common/themes/v2/img/support-cards-ar.png'
const SUPPORT_CARDS_KSA_URL = 'https://ui.cltp.co/flyinstatic/common/themes/v2/img/support-cards-ksa.png'
const SUPPORT_CARDS_KSA_AR_URL = 'https://ui.cltp.co/flyinstatic/common/themes/v2/img/support-cards-ksa-ar.png'

type SupportCardsImageInput = {
    locale: string
    hostname?: string
}

export const getSupportCardsImageSrc = ({ locale, hostname }: SupportCardsImageInput): string => {
    const isArabic = locale.toLowerCase() === 'ar'
    const isKsaHost = (hostname || '').toLowerCase() === 'www.flyin.com'

    if (isKsaHost) {
        return isArabic ? SUPPORT_CARDS_KSA_AR_URL : SUPPORT_CARDS_KSA_URL
    }

    return isArabic ? SUPPORT_CARDS_AR_URL : SUPPORT_CARDS_DEFAULT_URL
}
